//
//
//
//
//
//

export default {
  name: 'RuoYiGit',
  data: function data() {
    return {
      url: 'https://github.com/tiger1103/gfast-ui'
    };
  },
  methods: {
    goto: function goto() {
      window.open(this.url);
    }
  }
};